import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const GRADE = 'grade'
const SIGN = 'sign'
const NUMERIC = 'numeric'
const TEXT = 'text'
const SPECIAL = 'special'
const ZPD = 'zpd'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [GRADE]: {
      label: `${t('common.percentage')}`,
      name: GRADE,
      required: true,
    },
    [SIGN]: {
      label: `${t('common.letter-grade')}`,
      name: SIGN,
      required: true,
    },
    [NUMERIC]: {
      label: `${t('common.numeric-grade')}`,
      name: NUMERIC,
      required: true,
    },
    [TEXT]: {
      label: `${t('common.grade-definition')}`,
      name: TEXT,
      required: true,
    },
    [SPECIAL]: {
      label: `${t('common.special')}`,
      name: SPECIAL,
      required: true,
    },
    [ZPD]: {
      label: `${t('common.zpd-anchor')}`,
      name: ZPD,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GRADE]: '',
  [SIGN]: '',
  [NUMERIC]: '',
  [TEXT]: '',
  [SPECIAL]: '',
  [ZPD]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [GRADE]: yup.number().required(`${t('errors.required-error-message')}`),
    [SIGN]: yup.string().required(`${t('errors.required-error-message')}`),
    [NUMERIC]: yup.number().required(`${t('errors.required-error-message')}`),
    [TEXT]: yup.string().required(`${t('errors.required-error-message')}`),
    [SPECIAL]: yup.string().required(`${t('errors.required-error-message')}`),
    [ZPD]: yup.string().required(`${t('errors.required-error-message')}`),
  })

export default formModel
